import React from 'react';

import * as kratos from '@ory/kratos-client';

import {
  kratosApi,
  BodyValues,
  bodyValueExtractor
} from './kratos/common';

import { useInitFlow } from './kratos/useInitFlow';
import Flow from './kratos/Flow';

/*
React Component providing an (Account/Identity) Verification UI.
  ... WIP, pending required mail server config ...
*/
export default function Verification() {
  const flowType = 'verification';

  const {
    flowId, initFlowQuery, initFlowStatusElement
  } = useInitFlow(flowType, initFlow);

  if (flowId === '') {
    return initFlowStatusElement;
  }

  return <Flow
    flowId={flowId}
    flowType={flowType}
    flowGetter={getFlow}
    flowSubmitter={submitFlow(flowId)}
  />;
}


const initFlow = () => async () => await
  kratosApi.createBrowserVerificationFlow();

const getFlow = (flowId: string) => async () => await
  kratosApi.getVerificationFlow({ id: flowId });

const submitFlow = (flowId: string) => async (values: BodyValues) =>
{
  const v = bodyValueExtractor(values);

  // TODO: extractor keys probably wrong
  const body: kratos.UpdateVerificationFlowBody = {
    email: v('link-email'),
    method: v('link-method')
  };

  return await kratosApi.updateVerificationFlow({
    flow: flowId,
    updateVerificationFlowBody: body
  });
};
